import { RuntimeConfig } from '@nuxt/schema'
import { FetchError } from 'ofetch'
import { LocationQuery } from 'vue-router'
import NotFoundError from '../app/error/NotFoundError'
import { ListUserAddressesResponse, UpsertUserAddressResponse, UserAddress } from '~/models/Api/UserAddress'
import ViewProductResponse from '~/models/Api/ViewProductResponse'
import ProductAddonSaleAreasResponsePart from '~/models/Api/ProductAddonSaleAreasResponsePart'
import ProductSimilarProductsResponse from '~/models/Api/ProductSimilarProductsResponse'
import ProductRatingResponse from '~/models/Api/ProductRatingResponse'
import DiscussionGetWatchdog from '~/models/Api/DiscussionGetWatchdog'
import LikePost from '~/models/Discussion/LikePost'
import DisLikePost from '~/models/Discussion/DisLikePost'
import FavoriteInsertOrDeleteResponse from '~/models/Api/FavoriteInsertOrDeleteResponse'
import Review from '~/models/ReviewClub/Review'
import ProductAddonSaleBundleResponse from '~/models/Api/ProductAddonSaleBundleResponse'
import ProductDelivery from '~/models/Product/ProductDelivery'
import GiftEventProductsResponse from '~/models/Api/GiftEventProductsResponse'
import ReportRequestBody from '~/models/Discussion/ReportRequestBody'
import ProductFrequentlyActualizedData from '~/models/Api/ProductFrequentlyActualizedData'
import ProductFrequentlyActualizedDataCollection from '~/models/Api/ProductFrequentlyActualizedDataCollection'
import CommentAggregateResponse from '~/models/Api/CommentAggregateResponse'
import { AddonSaleBundleStrategy } from '~/models/Product/AddonSaleBundleStrategy'
import ViewCounsellingDetailResponse from '~/models/Api/Counselling/ViewCounsellingDetailResponse'
import ViewCounsellingHomepageResponse from '~/models/Api/Counselling/ViewCounsellingHomepageResponse'
import ViewCounsellingListResponse from '~/models/Api/Counselling/ViewCounsellingListResponse'
import ViewCounsellingListRequest from '~/models/Api/Counselling/ViewCounsellingListRequest'
import UpsertCounsellingPostRequest from '~/models/Api/Counselling/UpsertCounsellingPostRequest'
import UpsertCounsellingPostResponse from '~/models/Api/Counselling/UpsertCounsellingPostResponse'
import BasketProductCarouselsResponse from '~/models/Api/BasketProductCarouselsResponse'
import AddBasketVoucherSuccessResponse from '~/models/Api/AddBasketVoucherSuccessResponse'
import AddBasketVoucherErrorResponse from '~/models/Api/AddBasketVoucherErrorResponse'
import ViewBasketResponse from '~/models/Api/ViewBasketResponse'
import ViewPharmacyListRequest from '~/models/Api/Pharmacy/ViewPharmacyListRequest'
import ViewPharmacyListResponse from '~/models/Api/Pharmacy/ViewPharmacyListResponse'
import GeneralResponse from '~/models/Api/GeneralResponse'
import ViewPharmacyDetailResponse from '~/models/Api/Pharmacy/ViewPharmacyDetailResponse'
import ViewPharmacyProductsAvailabilityResponse from '~/models/Api/Pharmacy/ViewPharmacyProductsAvailabilityResponse'
import ComplaintHomepageResponse from '~/models/Api/Complaints/ComplaintHomepageResponse'
import ComplaintDetailResponse from '~/models/Api/Complaints/ComplaintDetailResponse'
import ComplaintUpsertResponse from '~/models/Api/Complaints/ComplaintUpsertResponse'
import OrdersForComplaintResponse from '~/models/Api/Complaints/OrdersForComplaintResponse'
import UpsertComplaintRequest from '~/models/Complaint/UpsertComplaintRequest'
import ComplaintFindOrderResponse from '~/models/Api/Complaints/ComplaintFindOrderResponse'
import ComplaintSlotsResponse from '~/models/Api/ComplaintSlotsResponse'
import ComplaintSettingsResponse from '~/models/Api/Complaints/ComplaintSettingsResponse'
import ViewStaticContentResponse from '~/models/Api/ViewStaticContentResponse'
import ViewOrderSentResponse from '~/models/Api/Cart/ViewOrderSentResponse'
import ViewArticleListResponse from '~/models/Api/Article/ViewArticleListResponse'
import PopUpRegistrationResponse from '~/models/Api/PopUpRegistrationResponse'
import DiscussionUpsertRequest from '~/models/Api/DIscussion/DiscussionUpsertRequest'
import Product from '~/models/Product/Product'
import WatchdogProductResponse from '~/models/Api/WatchdogProductResponse'
import ListLastBoughtRecommendedProductsResponse from '~/models/Api/ListLastBoughtRecommendedProductsResponse'
import InvalidAccessTokenException from '~/models/InvalidAccessTokenException'
import ListPickupPlacePointsRequest from '~/models/Api/Cart/ListPickupPlacePointsRequest'
import ListPickupPlacePointsResponse from '~/models/Api/Cart/ListPickupPlacePointsResponse'
import ListPickupPlacesRequest from '~/models/Api/Cart/ListPickupPlacesRequest'
import AddonSaleProductsResponse from '~/models/Api/AddonSaleProductsResponse'
import CreateBasketUserRequest from '~/models/Api/Cart/CreateBasketUserRequest'
import CartMiddlewareResponse from '~/models/Api/CartMiddlewareResponse'
import ValidateBasketPostCodeResponse from '~/models/Api/ValidateBasketPostCodeResponse'
import ViewBasketDeliveryDateTextResponse from '~/models/Api/ViewBasketDeliveryDateTextResponse'
import ShippingListGroup from '~/models/Api/Cart/ShippingListGroup'
import ListPickupPlacesResponse from '~/models/Api/Cart/ListPickupPlacesResponse'
import CreateBasketShippingRequest from '~/models/Api/Cart/CreateBasketShippingRequest'
import CreateBasketShippingResponse from '~/models/Api/Cart/CreateBasketShippingResponse'
import PaymentListGroup from '~/models/Api/Cart/PaymentListGroup'
import PremiumListResponse from '~/models/Api/Cart/PremiumListResponse'
import SlotsResponse from '~/models/Api/SlotsResponse'
import PwaShopBannersResponse from '~/models/Api/PwaShopBannersResponse'
import ProductRecoResponse from '~/models/Api/ProductRecoResponse'
import PickupPlace from '~/models/Api/Cart/PickupPlace'
import AltDeliverySlotsResponse from '~/models/Slot/AltDeliverySlotsResponse'
import ListPropertyOptionResponse from '~/models/Api/ListPropertyOptionResponse'
import ListUserCreditCardsResponse from '~/models/Api/Cart/ListUserCreditCardsResponse'
import GiftEventsDiscountPriceResponse from '~/models/Api/GiftEventsDiscountPriceResponse'
import BasketFastestPossibleDeliveryDateResponse from '~/models/Api/BasketFastestPossibleDeliveryDateResponse'
import ViewUserPremiumStatsResponse from '~/models/Api/ViewUserPremiumStatsResponse'
import { ViewOrderListResponse } from '~/models/Api/ViewOrderListResponse'
import { ViewOrderResponse } from '~/models/Api/ViewOrderResponse'
import { ListFavoriteProductsResponse } from '~/models/Api/ListFavoriteProductsResponse'
import { ViewReviewedProductsResponse } from '~/models/Api/ViewReviewedProductsResponse'
import { UpsertUserRequest } from '~/models/Api/UpsertUserRequest'
import CreditsHistoryItem from '~/models/Api/CreditsHistoryResponse'
import RegistrationRequest from '~/models/Api/RegistrationRequest'
import CreateCreditCardSessionResponse from '~/models/Api/CreateCreditCardSessionResponse'
import BrandAlphabeticalListResponse from '~/models/Api/Brand/BrandAlphabeticalListResponse'
import DiscussionPost from '~/models/DiscussionPost'
import PWAHomepage from '~/models/Api/PWAHomepage'
import { LoginVerifyResponse } from '~/models/Api/LoginVerifyResponse'
import { LoginResponse } from '~/models/Api/LoginResponse'
import CreateAdyenPilulkaPremiumSessionResponse from '~/models/Api/CreateAdyenPilulkaPremiumSessionResponse'
import ListPremiumExclusiveGiftEventsProductsResponse from '~/models/Api/ListPremiumExclusiveGiftEventsProductsResponse'
import Banner from '~/models/components/Banner'
import { LabLocationMapResponse, LabLocationDetail } from '~/models/Macromo'

interface AddCommentRequest {
    accessToken: string | null
    objectId: number
    name: string
    email: string
    text: string
    rating: number
    questionRatings: any
    pros: string[]
    cons: string[]
    type: number
    feedbackHash: string | null
    uid: string | null
}

interface SendFeedbackRequest {
    accessToken: string
    rating: number
    uid: string
    feedbackHash: string
    objectId: number
    type: number
    text: string
}

interface UpdateRaiffeisenDiscountCheckboxesRequest {
    uid: string
    isCheckboxEnabled: boolean
    isMarketingNotificationsCheckboxEnabled: boolean
}
interface UpdateRaiffeisenDiscountCheckboxesRequestHeaders {
    accessToken: string
}

export default class Repository {
    private config: RuntimeConfig
    private sentry

    constructor(config: RuntimeConfig, sentry: any) {
        this.config = config
        this.sentry = sentry
    }

    constructUrl(url: string): string {
        if (process.client) {
            return `${this.config.public.apiUrl}${url}`
        } else {
            return `${this.config.public.apiUrlInsideDocker}${url}`
        }
    }

    async getCustomAddonSaleCarousels() {
        const url = this.constructUrl(`/api/v2/product/custom-addon-sale-carousels`)
        const response = await fetch(url)

        if (response.status === 200) {
            return (await response.json()).response
        } else {
            throw new Error('Addon salses data could not be loaded.')
        }
    }

    async getProductAddonSaleAreas(productId: number): Promise<ProductAddonSaleAreasResponsePart[]> {
        const url = this.constructUrl(`/api/v2/product/addon-sale-areas?productId=${productId}`)
        const response = await fetch(url)

        if (response.status === 200) {
            return (await response.json()).response
        } else {
            throw new Error('Addon salses data could not be loaded.')
        }
    }

    async getProductFrequentlyActualizedData(
        productIds: number[],
        uid: string,
        needsDetailedInfo: boolean = false
    ): Promise<ProductFrequentlyActualizedDataCollection> {
        const headers = {
            platform: 'pwa',
        }
        const response = await this.getData(
            `/api/v2/product/frequently-actualized-data`,
            {
                ids: productIds,
                needsDetailedInfo,
                uid,
            },
            headers
        )
        const dataAsArray: ProductFrequentlyActualizedData[] = response.products

        const collection: ProductFrequentlyActualizedDataCollection = {}
        dataAsArray.forEach((data) => {
            collection[data.id] = data
        })

        return collection
    }

    async getProductSimilarProducts(productId: number, minAmountInStock: number): Promise<ProductSimilarProductsResponse> {
        const url = this.constructUrl(`/api/v2/product/similar?productId=${productId}&minAmountInStock=${minAmountInStock}`)
        const response = await fetch(url)

        if (response.status === 200) {
            return (await response.json()).response
        } else {
            throw new Error('Similar products data could not be loaded.')
        }
    }

    async getAddonSaleProducts(uid: string): Promise<GeneralResponse<AddonSaleProductsResponse>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            `/api/v2/basket/addon-sale-product/list`,
            {
                uid,
            },
            headers
        )
    }

    async listPremiumExclusiveGiftEventsProducts(): Promise<GeneralResponse<ListPremiumExclusiveGiftEventsProductsResponse[]>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(`/api/v2/product/list-premium-exclusive-gift-events-products`, {}, headers)
    }

    async logError(message: string): Promise<GeneralResponse<{}>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            `/api/v2/log/error`,
            {
                message,
            },
            headers
        )
    }

    async viewShippingList(uid: string, accessToken: string): Promise<GeneralResponse<ShippingListGroup[]>> {
        const headers = {
            platform: 'pwa',
            accessToken: '',
        }

        if (accessToken) {
            headers.accessToken = accessToken
        }

        return await this.getDataWithGeneralResponse(
            `/api/v3/shipping/list`,
            {
                uid,
            },
            headers
        )
    }

    async getSlotsForAltDelivery(zip: string, uid: string): Promise<GeneralResponse<AltDeliverySlotsResponse>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            `/api/v2/car/pilulka-slots-for-alt-delivery`,
            {
                zip,
                uid,
            },
            headers
        )
    }

    async viewPaymentList(uid: string, accessToken: string, shippingType: string): Promise<GeneralResponse<PaymentListGroup[]>> {
        const headers = {
            platform: 'pwa',
            accessToken: '',
        }

        if (accessToken) {
            headers.accessToken = accessToken
        }

        return await this.getDataWithGeneralResponse(
            `/api/v2/payment/list`,
            {
                uid,
                shippingType,
                allowHtmlDescription: true,
            },
            headers
        )
    }

    async changeDeliveryToInternal(slot: string, uid: string, zip: string): Promise<GeneralResponse<AltDeliverySlotsResponse>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            `/api/v2/basket/change-to-internal-delivery`,
            {
                slot,
                zip,
                uid,
            },
            headers
        )
    }

    async viewPremiumList(): Promise<GeneralResponse<PremiumListResponse>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(`/api/v2/product/premium/list`, {}, headers)
    }

    async getCounsellingDetail(counsellingPostId: number): Promise<GeneralResponse<ViewCounsellingDetailResponse>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            `/api/v2/counselling/detail`,
            {
                id: counsellingPostId,
            },
            headers
        )
    }

    async getCounsellingHomepage(): Promise<ViewCounsellingHomepageResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getData(`/api/v2/counselling/homepage`, {}, headers)
    }

    async getCounsellingList(request: ViewCounsellingListRequest): Promise<ViewCounsellingListResponse> {
        return await this.getData('/api/v2/counselling/list', request)
    }

    async upsertCounsellingPost(request: UpsertCounsellingPostRequest): Promise<UpsertCounsellingPostResponse> {
        return await this.getData('/api/v2/counselling/upsert', request)
    }

    async getPharmacyList(request: ViewPharmacyListRequest): Promise<GeneralResponse<ViewPharmacyListResponse>> {
        return await this.getDataWithGeneralResponse('/api/v3/pharmacy/list', request)
    }

    async getPharmacyDetail(pharmacyId: number): Promise<GeneralResponse<ViewPharmacyDetailResponse>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            `/api/v3/pharmacy/view`,
            {
                id: pharmacyId,
            },
            headers
        )
    }

    async getOrderSentDetail(orderNumberToken: string): Promise<ViewOrderSentResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getData(`/api/v2/order/sent`, { orderNumberToken }, headers)
    }

    async sendTargitoS2S(orderNumberToken: string, trgid: string, trgm: string, trgd: string): Promise<ViewOrderSentResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getData(
            `/api/v2/order/targito-s2s`,
            {
                orderNumberToken,
                trgid,
                trgm,
                trgd,
            },
            headers
        )
    }

    async getComplaintHomepage(accessToken: string): Promise<GeneralResponse<ComplaintHomepageResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getDataWithGeneralResponse(`/api/v2/complaint/homepage`, {}, headers)
    }

    async getComplaintDetail(accessToken: string, complaintNumber: string): Promise<GeneralResponse<ComplaintDetailResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getDataWithGeneralResponse(`/api/v2/complaint/view`, { complaintNumber }, headers)
    }

    async upsertComplaint(accessToken: string, complaint: UpsertComplaintRequest): Promise<GeneralResponse<ComplaintUpsertResponse>> {
        const headers = {
            platform: 'pwa',
        } as { [name: string]: string }

        if (accessToken && accessToken !== '') {
            headers.accessToken = accessToken
        }

        const fd = new FormData()
        fd.append('orderNumber', complaint.orderNumber)
        fd.append('shipping', complaint.shipping || '')
        fd.append('complaintType', String(complaint.complaintType))
        fd.append('complaintReason', String(complaint.complaintReason))
        fd.append('complaintNote', complaint.complaintNote === null ? '' : complaint.complaintNote)
        fd.append('productAmounts', JSON.stringify(complaint.productAmounts))
        fd.append('serviceId', complaint.complaintServiceId === null ? '' : String(complaint.complaintServiceId))
        fd.append('address', JSON.stringify(complaint.address))
        fd.append('bankAccount', JSON.stringify(complaint.bankAccount))
        fd.append('date', complaint.date || '')
        fd.append('slot', complaint.slot === null ? '' : complaint.slot)
        fd.append('refundMethod', complaint.refundMethod || '')
        complaint.files?.forEach((file) => {
            fd.append('files[]', file)
        })

        return await this.getDataWithGeneralResponse(`/api/v2/complaint/upsert`, fd, headers)
    }

    async getOrdersForComplaint(accessToken: string): Promise<OrdersForComplaintResponse> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getData(`/api/v2/complaint/orders`, {}, headers)
    }

    async getComplaintSettings(): Promise<ComplaintSettingsResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getData(`/api/v2/complaint/settings`, {}, headers)
    }

    async getProductDetailDataAccess(id: number, uid: string = ''): Promise<ViewProductResponse> {
        return await this.getData(`/api/v2/product/view`, {
            id,
            uid,
            skipSaleAreas: true,
            skipSimilarProducts: true,
            skipDeliveries: true,
            showExpresData: true,
        })
    }

    async upsertProductBasket(
        uid: string,
        products: { productId: number; amount: number; voucherCode: string | null; hasAddonSalePrice?: boolean }[],
        accessToken: string,
        shouldAddCustomAddonSaleCarousels: boolean
    ) {
        const headers = {
            Accept: `application/vnd.pilulka.basket.lite+json;version=1.0`,
            platform: 'pwa',
            accessToken: '',
        }

        if (accessToken) {
            headers.accessToken = accessToken
        }

        return await this.getData(
            `/api/v2/basket/product/upsert`,
            {
                uid,
                products,
                shouldAddCustomAddonSaleCarousels,
            },
            headers
        )
    }

    async cartStep1Middleware(uid: string, accessToken: string): Promise<GeneralResponse<CartMiddlewareResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken: '',
        }

        if (accessToken) {
            headers.accessToken = accessToken
        }

        return await this.getDataWithGeneralResponse(
            `/api/v2/middleware/cart-step-1`,
            {
                uid,
            },
            headers
        )
    }

    async cartStep2Middleware(uid: string, accessToken: string): Promise<GeneralResponse<CartMiddlewareResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken: '',
        }

        if (accessToken) {
            headers.accessToken = accessToken
        }

        return await this.getDataWithGeneralResponse(
            `/api/v2/middleware/cart-step-2`,
            {
                uid,
            },
            headers
        )
    }

    async updateRaiffeisenDiscountCheckboxes(
        body: UpdateRaiffeisenDiscountCheckboxesRequest,
        headers: UpdateRaiffeisenDiscountCheckboxesRequestHeaders
    ) {
        const newHeaders = {
            platform: 'pwa',
            ...headers,
        }

        return await this.getData(`/api/v2/basket/raiffeisen-discount-checkboxes`, body, newHeaders)
    }

    async generateBasketUid(accessToken: string): Promise<string> {
        const headers = { platform: 'pwa', accessToken: '' }

        if (accessToken) {
            headers.accessToken = accessToken
        }

        const response = await this.getData(`/api/v2/basket/uid`, headers)

        return response.uid
    }

    async getProductDetailData(id: number, uid: string) {
        const headers = {}
        return await this.getData(
            `/api/v2/product/view`,
            {
                id,
                uid,
            },
            headers
        )
    }

    async getProductDeliveries(productId: number, uid: string): Promise<ProductDelivery[]> {
        const params = new URLSearchParams({ productId: String(productId), uid })
        const url = this.constructUrl(`/api/v2/product/deliveries?${params}`)
        const response = await fetch(url)
        if (response.status === 200) {
            return (await response.json()).response
        }
        throw new Error(`Product deliveries could not be loaded for productId ${productId}.`)
    }

    async getProductDeliveryGroups(productId: number, uid: string, accessToken: string): Promise<ShippingListGroup[]> {
        const headers: any = { platform: 'pwa' }
        if (accessToken) {
            headers.accessToken = accessToken
        }

        return await this.getData(`/api/v2/product/delivery-groups`, { productId, uid }, headers)
    }

    async getFastestPossibleDeliveryDate(uid: string): Promise<GeneralResponse<BasketFastestPossibleDeliveryDateResponse>> {
        const headers = { platform: 'pwa' }

        return await this.getDataWithGeneralResponse(
            '/api/v2/basket/fastest-possible-delivery-date',
            {
                uid,
            },
            headers
        )
    }

    async getPharmacyProductsAvailability(id: number, name?: string): Promise<ViewPharmacyProductsAvailabilityResponse> {
        return await this.getData(`/api/v2/pharmacy/product/view`, {
            productId: id,
            pharmacyName: name,
        })
    }

    async getProductReviewlist(id: number): Promise<Review[]> {
        return await this.getData(`/api/v2/review-club/list`, {
            productId: id,
        })
    }

    async getProductReviewDetail(id: number): Promise<Review> {
        return await this.getData(`/api/v2/review-club/view`, {
            reviewId: id,
        })
    }

    async getBasketProductCarousels(
        uid: string,
        variant: string,
        luigisBoxUserId: string = ''
    ): Promise<GeneralResponse<BasketProductCarouselsResponse>> {
        return await this.getDataWithGeneralResponse(
            `/api/v2/basket/product-carousels`,
            {
                uid,
                variant,
                luigisBoxUserId,
            },
            {
                Accept: `application/vnd.pilulka.basket.carousels+json;version=1.0`,
            }
        )
    }

    async createBasketUser(request: CreateBasketUserRequest, accessToken: string | undefined | null) {
        const headers = {
            accessToken: accessToken || '',
        }

        return await this.getDataWithGeneralResponse(`/api/v3/basket/customer/insert`, request, headers)
    }

    async createBasketShipping(
        request: CreateBasketShippingRequest,
        accessToken: string | undefined | null
    ): Promise<GeneralResponse<CreateBasketShippingResponse>> {
        const headers = {
            accessToken: accessToken || '',
        }

        return await this.getData(`/api/v2/basket/shipping/insert`, request, headers)
    }

    async getBasket(uid: string): Promise<GeneralResponse<ViewBasketResponse>> {
        return await this.getDataWithGeneralResponse(
            `/api/v2/basket`,
            {
                uid,
            },
            {
                Accept: `application/vnd.pilulka.basket+json;version=1.0`,
            }
        )
    }

    async listPickupPlacePoints(
        request: ListPickupPlacePointsRequest,
        accessToken: string
    ): Promise<GeneralResponse<ListPickupPlacePointsResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getDataWithGeneralResponse(`/api/v2/pickup-place/list-points`, request, headers)
    }

    async listUserCreditCards(accessToken: string): Promise<GeneralResponse<ListUserCreditCardsResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getDataWithGeneralResponse(`/api/v2/credit-card/list`, {}, headers)
    }

    async setUserCreditCardAsPrimary(userCreditCardId: number, accessToken: string): Promise<GeneralResponse<ListUserCreditCardsResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getDataWithGeneralResponse(`/api/v2/credit-card/set-as-primary`, { userCreditCardId }, headers)
    }

    async deleteUserCreditCard(userCreditCardId: number, accessToken: string): Promise<GeneralResponse<ListUserCreditCardsResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getDataWithGeneralResponse(`/api/v2/credit-card/delete`, { id: userCreditCardId }, headers)
    }

    async listPickupPlaces(request: ListPickupPlacesRequest, accessToken: string): Promise<GeneralResponse<ListPickupPlacesResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getDataWithGeneralResponse(`/api/v2/pickup-place/list`, request, headers)
    }

    async createCreditCardSession(accessToken: string): Promise<GeneralResponse<CreateCreditCardSessionResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getDataWithGeneralResponse(`/api/v2/pay/adyen/credit-card-session`, {}, headers)
    }

    async calculatePilulkaPremiumPrice(
        accessToken: string,
        premiumProductId: number,
        voucherCode?: string
    ): Promise<
        GeneralResponse<{
            originalPrice: number
            finalPrice: number
            discount: number
            voucherValid: boolean
            errorMessage: string | null
            trialLengthInMonths: number
        }>
    > {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        const payload: { premiumProductId: number; voucherCode?: string } = {
            premiumProductId,
        }

        if (voucherCode) {
            payload.voucherCode = voucherCode
        }

        return await this.getDataWithGeneralResponse(`/api/v2/user/premium/calculate-price`, payload, headers)
    }

    async activatePilulkaPremium(
        accessToken: string,
        premiumProductId: number,
        userCreditCardId: number,
        voucherCode?: string
    ): Promise<GeneralResponse<CreateAdyenPilulkaPremiumSessionResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        const payload: { premiumProductId: number; userCreditCardId: number; voucherCode?: string } = {
            premiumProductId,
            userCreditCardId,
        }

        if (voucherCode) {
            payload.voucherCode = voucherCode
        }

        return await this.getDataWithGeneralResponse(`/api/v2/pay/adyen/activate-pilulka-premium`, payload, headers)
    }

    async createAdyenPilulkaPremiumSession(
        accessToken: string,
        premiumProductId: number
    ): Promise<GeneralResponse<CreateAdyenPilulkaPremiumSessionResponse>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getDataWithGeneralResponse(`/api/v2/pay/adyen/pilulka-premium-session`, { premiumProductId }, headers)
    }

    async storeUserCreditCard(accessToken: string): Promise<GeneralResponse<{ lastCreditCardId: number | null }>> {
        const headers = {
            platform: 'pwa',
            accessToken,
        }

        return await this.getDataWithGeneralResponse(`/api/v2/pay/adyen/store-credit-card`, {}, headers)
    }

    async viewPickupPlace(id: number, shippingType: string): Promise<GeneralResponse<PickupPlace>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            `/api/v2/pickup-place/view`,
            {
                id,
                shippingType,
            },
            headers
        )
    }

    async listPropertyOptions(paramGroup: number): Promise<GeneralResponse<ListPropertyOptionResponse>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            `/api/v2/property-option/list`,
            {
                paramGroup,
            },
            headers
        )
    }

    async addBasketVoucher(uid: string, voucherCode: string): Promise<AddBasketVoucherSuccessResponse | AddBasketVoucherErrorResponse> {
        const response: GeneralResponse<AddBasketVoucherSuccessResponse | AddBasketVoucherErrorResponse> = await $fetch(
            this.constructUrl(`/api/v2/basket/voucher/insert`),
            {
                method: 'POST',
                headers: {
                    platform: 'pwa',
                },
                body: {
                    uid,
                    voucherCode,
                },
            }
        )

        return response.response
    }

    async deleteBasketVoucher(uid: string, voucherCode: string): Promise<void> {
        await this.getData(`/api/v2/basket/voucher/delete`, {
            uid,
            voucherCode,
        })
    }

    async useBasketCredits(uid: string, useCredits: boolean): Promise<void> {
        return await this.getData(`/api/v2/basket/credits/use`, {
            uid,
            useCredits,
        })
    }

    async getVouchers({ accessToken }: { accessToken: string }) {
        return await this.getData(`/api/v2/service-voucher/list`, {}, { accessToken })
    }

    async getProductsByIds(ids: number[], preserveIdsOrder: boolean, uid: string) {
        const body = { ids, preserveIdsOrder, uid }

        return await this.getData(`/api/v2/product/_by_ids`, body)
    }

    async getProductRatingByIds(ids: number[]): Promise<ProductRatingResponse> {
        const productIds = ids
        return await this.getData(`/api/v2/product/rating`, { productIds })
    }

    async addFavorite(id: number, { accessToken }: { accessToken: string }): Promise<FavoriteInsertOrDeleteResponse> {
        return await this.getData('/api/v2/favorite/insert', { id: [id] }, { accessToken })
    }

    async removeFavorite(id: number, { accessToken }: { accessToken: string }): Promise<FavoriteInsertOrDeleteResponse> {
        return await this.getData('/api/v2/favorite/delete', { id: [id] }, { accessToken })
    }

    async getComments({
        objectId,
        type,
        offset,
        limit,
        isVerifiedPurchase,
    }: {
        objectId: number
        type: number
        offset: number
        limit: number
        isVerifiedPurchase: boolean
    }) {
        return await this.getData(`/api/v2/review/list`, {
            objectId,
            type,
            from: offset,
            size: limit,
            isVerifiedPurchase: isVerifiedPurchase || false,
        })
    }

    async rateComment({ uid, isUseful, accessToken }: { uid: string; isUseful: boolean; accessToken: string }) {
        return await this.getData('/api/v2/review/isuseful', { uid, isUseful }, { accessToken })
    }

    async addComment(request: AddCommentRequest) {
        const headers = request.accessToken ? { accessToken: request.accessToken } : {}

        return await this.getData(
            `/api/v2/review/upsert`,
            {
                uid: request.uid,
                objectId: request.objectId,
                type: request.type,
                name: request.name,
                email: request.email,
                text: request.text,
                rating: request.rating,
                questionRatings: request.questionRatings,
                pros: request.pros,
                cons: request.cons,
                feedbackHash: request.feedbackHash,
            },
            headers
        )
    }

    async getReviewUserByFeedbackHash({ feedbackHash }: { feedbackHash: string }) {
        return await this.getData(`/api/v2/review/view-user`, {
            feedbackHash,
        })
    }

    async rateReviewClub({ reviewId, type, accessToken }: { reviewId: number; type: 'like' | 'dislike'; accessToken: string }) {
        return await this.getData('/api/v2/review-club/rate', { reviewId, type }, { accessToken })
    }

    async sendFeedback(request: SendFeedbackRequest) {
        const headers: any = {}
        if (request.accessToken) {
            headers.accessToken = request.accessToken
        }

        return await this.getData(
            `/api/v3/feedback/save`,
            {
                rating: request.rating,
                uid: request.uid,
                feedbackHash: request.feedbackHash,
                objectId: request.objectId,
                type: request.type,
                text: request.text,
            },
            headers
        )
    }

    async sendFormRecommend(data: { fullName: string; email: string; message: string }) {
        return await this.getData(`/api/v2/suggest-missing-product/send`, data)
    }

    async getSelectedDiscussionsList(
        productId: number | null,
        categoryId: number | null,
        { accessToken }: { accessToken: string | null }
    ): Promise<DiscussionPost[]> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getData('/api/v2/discussion/list', { productId, categoryId }, headers)
    }

    saveCjEventId(query: LocationQuery, accessToken: string) {
        const { cjevent } = query

        if (!cjevent) {
            return
        }

        useCjEventCookie().value = cjevent as string
        return $fetch(this.constructUrl(`/backend/save-event-id/${cjevent}`), {
            headers: { accessToken },
        })
    }

    async validateAndRegisterUser(email: string, agreement: boolean, newsletterDisagree: boolean): Promise<PopUpRegistrationResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getData(
            '/api/v2/pop-up/registration',
            {
                email,
                agreement,
                newsletterDisagree,
            },
            headers
        )
    }

    async upsertWatchdogProduct(
        productId: number,
        email: string,
        agreement: boolean,
        newsletterDisagree: boolean
    ): Promise<WatchdogProductResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getData(
            '/api/v2/product/watchdog/upsert',
            {
                productId,
                email,
                agreement,
                newsletterDisagree,
            },
            headers
        )
    }

    async renewWatchdogProduct(hash: string, renew: boolean): Promise<WatchdogProductResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getData(
            '/api/v2/product/watchdog/renew',
            {
                hash,
                renew,
            },
            headers
        )
    }

    async validatePostCode(postCode: string, uid: string = ''): Promise<GeneralResponse<{ isAvailable: boolean; isValid: boolean }>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            '/api/v2/car/pilulka-postcode',
            {
                uid,
                postCode,
            },
            headers
        )
    }

    async validateEmail(email: string): Promise<{ exists: boolean; message: string }> {
        return await this.getData('/api/v2/validation/email', {
            email,
        })
    }

    async getComplaintSlots(postCode: string, delay: number): Promise<ComplaintSlotsResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getData(
            '/api/v2/complaint/pilulka-car-slots',
            {
                postCode,
                delayInDays: delay,
            },
            headers
        )
    }

    async getSlots(uid: string): Promise<GeneralResponse<SlotsResponse>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            '/api/v3/car/pilulka-slots',
            {
                uid,
            },
            headers
        )
    }

    async discussionReport(requestBody: ReportRequestBody) {
        return await this.getData(`/api/v2/discussion/report`, {
            requestBody,
        })
    }

    async discussionUpsertWatchdog(productId: number, notificationFrequency: string, { accessToken }: { accessToken: string }) {
        const headers = accessToken ? { accessToken } : {}
        const requestData = { productId, notificationFrequency }

        return await this.getData('/api/v2/discussion/upsert-watchdog', requestData, headers)
    }

    async discussionUpsert(requestBody: DiscussionUpsertRequest, { accessToken }: { accessToken: string }) {
        const headers = accessToken ? { accessToken } : {}

        return await this.getData('/api/v2/discussion/upsert', requestBody, headers)
    }

    async discussionGetWatchdog(productId: number, { accessToken }: { accessToken: string }): Promise<DiscussionGetWatchdog[]> {
        const headers = accessToken ? { accessToken } : {}
        const requestData = { productId }

        return await this.getData('/api/v2/discussion/get-watchdog', requestData, headers)
    }

    async discussionLikePost(postId: number, { accessToken }: { accessToken: string }): Promise<LikePost> {
        const requestData = { postId }
        const headers = accessToken ? { accessToken } : {}

        return await this.getData('/api/v2/discussion/like', requestData, headers)
    }

    async discussionDislikePost(postId: number, { accessToken }: { accessToken: string }): Promise<DisLikePost> {
        const requestData = {
            postId,
        }
        const headers = accessToken ? { accessToken } : {}

        return await this.getData('/api/v2/discussion/dislike', requestData, headers)
    }

    async getCategoryProductListBanners(id: number) {
        const requestData = {
            id,
        }

        return await this.getData('/api/v2/category/product-list-banners', requestData)
    }

    async getShopBanners(): Promise<PwaShopBannersResponse> {
        return await this.getData('/api/v2/pwa/shop-banners')
    }

    async getStaticPage(url: string) {
        const {
            headInfo,
            params: { slug },
        } = await this.getRouteProperties(url)

        const response = await this.getStaticPageWidgets(slug)

        return { ...response, headInfo }
    }

    logConsentChange(cookieName: string, status: 'granted' | 'denied', clientId: string | null = null) {
        this.getData('/api/v2/cookie/log/upsert', {
            cookieName,
            clientId,
            isAllowed: status === 'granted',
        })
    }

    getStaticPageWidgets(slug: string): Promise<ViewStaticContentResponse> {
        return this.getData('/api/v3/content/static/view', { slug })
    }

    getRouteProperties(url: string) {
        return this.getData('/api/v2/pwa/router', { url })
    }

    getCommentAggregate(id: Number, type: string): Promise<CommentAggregateResponse> {
        return this.getData('/api/v2/comment/aggregate', { id, type })
    }

    getArticleList(currentUrl: string, page: number, filter: Object, sort: number): Promise<GeneralResponse<ViewArticleListResponse>> {
        return this.getDataWithGeneralResponse('/api/v2/article/list', { page, currentUrl, filter, sort })
    }

    getBrandsAlphabeticalList(): Promise<GeneralResponse<BrandAlphabeticalListResponse>> {
        return this.getDataWithGeneralResponse('/api/v2/brand/alphabetical-list')
    }

    getPwaMenu() {
        const headers = {
            Accept: 'application/json;version=1.0',
        }

        return this.getData('/api/v2/pwa/menu', {}, headers)
    }

    async getPWAHomepageData({
        accessToken,
        response,
        uid,
    }: {
        accessToken: string | null
        response: string[]
        uid: string | null
    }): Promise<GeneralResponse<PWAHomepage>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse('/api/v2/pwa/homepage', { response, uid }, headers)
    }

    async listLastBoughtRecommendedProducts({
        accessToken,
        uid,
    }: {
        accessToken: string
        uid: string
    }): Promise<GeneralResponse<ListLastBoughtRecommendedProductsResponse>> {
        const headers = { accessToken }

        return await this.getDataWithGeneralResponse('/api/v2/user/last-bought-recommended-products', { uid }, headers)
    }

    async viewBasketDeliveryDateText(uid: string): Promise<GeneralResponse<ViewBasketDeliveryDateTextResponse>> {
        return await this.getDataWithGeneralResponse('/api/v2/basket/delivery-date', { uid })
    }

    async validateBasketPostCode(
        postCode: string,
        uid: string,
        accessToken: string | null,
        validatePilulkaExpres: boolean = false
    ): Promise<GeneralResponse<ValidateBasketPostCodeResponse>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(
            `/api/v2/location/validate/postcode/${postCode}`,
            { uid, validatePilulkaExpres },
            headers
        )
    }

    async getMacromoBloodTestRedirectUrl(accessToken: string): Promise<GeneralResponse<{ redirectUrl: string }>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(`/api/v2/macromo/appointment-redirect`, {}, headers)
    }

    async viewUserPremiumStats(accessToken: string): Promise<GeneralResponse<ViewUserPremiumStatsResponse>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(`/api/v2/user/premium/stats`, {}, headers)
    }

    async listCreditsHistory(accessToken: string): Promise<GeneralResponse<CreditsHistoryItem[]>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse('/api/v2/club/transaction/list', {}, headers)
    }

    async viewOrderList(accessToken: string, from: number, size: number): Promise<GeneralResponse<ViewOrderListResponse>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(
            `/api/v2/order/list`,
            {
                from,
                size,
            },
            headers
        )
    }

    async viewOrder(accessToken: string, orderNumber: string): Promise<GeneralResponse<ViewOrderResponse>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(
            `/api/v2/order/view`,
            {
                id: orderNumber,
            },
            headers
        )
    }

    async deactivateUserPremium(accessToken: string): Promise<GeneralResponse<{}>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(`/api/v2/user/premium/deactivate-subscription`, {}, headers)
    }

    async acceptPremiumSaveOffer(accessToken: string): Promise<GeneralResponse<{ nextPaymentDate: string }>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(`/api/v2/user/premium/save-offer/accept`, {}, headers)
    }

    async cancelPremiumWithReason(
        accessToken: string,
        reasons: string[],
        additionalInfo: string | null,
        channel: 'web' | 'backoffice' = 'web'
    ): Promise<GeneralResponse<{}>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(
            `/api/v2/user/premium/cancel-with-reason`,
            { reasons, additionalInfo, channel },
            headers
        )
    }

    async reactivatePremiumSubscription(accessToken: string): Promise<GeneralResponse<{}>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(`/api/v2/user/premium/reactivate-subscription`, {}, headers)
    }

    async switchPilulkaPremiumSubscriptionToAnnual(accessToken: string): Promise<GeneralResponse<{ message: string }>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(`/api/v2/user/premium/switch-pilulka-premium-subscription-to-annual`, {}, headers)
    }

    async upsertUser(accessToken: string, request: UpsertUserRequest): Promise<GeneralResponse<{}>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(`/api/v2/user/upsert`, request, headers)
    }

    async viewFavoriteProducts(accessToken: string, from: number, size: number): Promise<GeneralResponse<ListFavoriteProductsResponse>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(
            `/api/v2/favorite/list`,
            {
                from,
                size,
            },
            headers
        )
    }

    async viewUsersReviewedProducts(accessToken: string): Promise<GeneralResponse<ViewReviewedProductsResponse>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(`/api/v2/user/view-reviewed-products`, {}, headers)
    }

    async changePassword(
        accessToken: string,
        oldPassword: string,
        newPassword: string,
        newPasswordVerify: string
    ): Promise<GeneralResponse<{}>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(
            `/api/v2/password/change`,
            {
                oldPassword,
                newPassword,
                newPasswordVerify,
            },
            headers
        )
    }

    async updateUserSettings(accessToken: string, isSubscribed: boolean): Promise<GeneralResponse<{}>> {
        const headers = accessToken ? { accessToken } : {}

        return await this.getDataWithGeneralResponse(
            `/api/v2/user/update-settings`,
            {
                isSubscribed,
            },
            headers
        )
    }

    async resetPassword(email: string): Promise<GeneralResponse<{}>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse('/api/v2/password/reset', { email }, headers)
    }

    async registerUser(request: RegistrationRequest): Promise<GeneralResponse<{ message: string }>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse('/api/v2/registration', request, headers)
    }

    async login(email: string, password: string, uid: string): Promise<GeneralResponse<LoginResponse>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            '/api/v3/login',
            {
                email,
                password,
                uid,
            },
            headers
        )
    }

    async loginVerify(attemptId: string, code: string, uid: string): Promise<LoginVerifyResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            '/api/v3/login/verify',
            {
                attemptId,
                code,
                uid,
            },
            headers
        )
    }

    async verifyEmail(token: string): Promise<GeneralResponse<{ success: boolean; message: string }>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse(
            '/api/v3/user/email-verify',
            {
                token,
            },
            headers
        )
    }

    async findComplaintOrder(orderNumber: string, lastName: string): Promise<ComplaintFindOrderResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getData(
            '/api/v2/complaint/find-order',
            {
                orderNumber,
                lastName,
            },
            headers
        )
    }

    async getCsrProducts() {
        return await this.getData('/api/v2/product/csr/list')
    }

    async getAddonSaleBundles(
        productId: number,
        strategy: AddonSaleBundleStrategy,
        excludeProducts: number[] = []
    ): Promise<ProductAddonSaleBundleResponse> {
        return await this.getData(`/api/v2/product/addon-sale-bundles`, {
            id: productId,
            strategy,
            excludeProducts,
        })
    }

    async getGiftEventProducts(uid: string, giftEventIds: number[] = []): Promise<GiftEventProductsResponse> {
        return await this.getData(`/api/v2/product/gift-events/active-products`, {
            uid,
            giftEventIds,
        })
    }

    async getRecoProducts(
        type: string,
        productId: number | null,
        uid: string | null,
        luigisBoxUserId: string
    ): Promise<ProductRecoResponse> {
        return await this.getData(`/api/v2/product/reco-list`, {
            type,
            productId,
            uid,
            luigisBoxUserId,
        })
    }

    async getGiftEventsDiscountPrice(
        uid: string,
        giftEventIds: number[] = [],
        productIds: number[] = []
    ): Promise<GiftEventsDiscountPriceResponse> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getData(
            `/api/v2/product/gift-events/discount-price`,
            {
                uid,
                giftEventIds,
                productIds,
            },
            headers
        )
    }

    async getCustomHomepageAddonSaleCarousels(): Promise<
        {
            position: string
            products: Product[]
            title: string
            titleLink: string
        }[]
    > {
        const headers = {
            platform: 'pwa',
        }

        const response = await this.getData('/api/v2/home/view-partial', {
            partialName: 'customHomepageAddonSaleCarousels',
            headers,
        })

        return response.customHomepageAddonSaleCarousels
    }

    async getHomepageUpperBanners(): Promise<GeneralResponse<{ upperBanners: Banner[] }>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse('/api/v2/home/view-partial', {
            partialName: 'upperBanners',
            headers,
        })
    }

    async getHomepageUpperCarouselBanners(): Promise<GeneralResponse<{ upperCarouselBanners: Banner[] }>> {
        const headers = {
            platform: 'pwa',
        }

        return await this.getDataWithGeneralResponse('/api/v2/home/view-partial', {
            partialName: 'upperCarouselBanners',
            headers,
        })
    }

    async getLabLocationsMap(request: {
        north: number
        east: number
        south: number
        west: number
        zoom: number
    }): Promise<LabLocationMapResponse> {
        return await $fetch<LabLocationMapResponse>('https://api.macromoengine.com/pilulka/locations/map', {
            method: 'GET',
            params: request,
        })
    }

    async getLabLocationDetails(labLocationId: number): Promise<LabLocationDetail> {
        const response = await $fetch<LabLocationDetail[]>('https://api.macromoengine.com/pilulka/locations/details', {
            method: 'POST',
            body: {
                ids: [labLocationId],
            },
        })

        return response[0]
    }

    async getLabLocationsList(lat: number | null = null, lon: number | null = null): Promise<LabLocationDetail[]> {
        const params: { limit: number; lat?: number; lon?: number } = {
            limit: 100,
        }
        if (lat) {
            params.lat = lat
        }
        if (lon) {
            params.lon = lon
        }
        return await $fetch<LabLocationDetail[]>('https://api.macromoengine.com/pilulka/locations', {
            method: 'GET',
            params,
        })
    }

    async getData(url: string, inputData = {}, headers: any = {}) {
        let response = null
        try {
            headers.platform = 'pwa'
            response = await $fetch(this.constructUrl(url), {
                method: 'POST',
                headers,
                body: inputData,
            })
        } catch (e: unknown) {
            if (e instanceof FetchError) {
                const errorMessage = `Data could not be loaded from url ${url}. InputData: ${JSON.stringify(inputData)}. ${e}. Response: ${
                    e.response
                }`
                this.sentry?.sentryCaptureException?.(errorMessage, {
                    extra: {
                        fullMessage: errorMessage,
                    },
                })

                throw new Error(errorMessage)
            }

            this.sentry?.sentryCaptureException?.(e)

            throw e
        }

        const data: any = response
        const result = data.result
        const responseData = data.response

        if (result) {
            return responseData
        } else if (data.code === 301) {
            throw new InvalidAccessTokenException('Invalid access token')
        } else if (data.code === 300 || data.code === 307) {
            return data
        } else {
            const Exception = data.code === 404 ? NotFoundError : Error

            throw new Exception(
                `Data could not be loaded from url ${url}. InputData: ${JSON.stringify(inputData)}. Message ${data.message}`
            )
        }
    }

    async getDataWithGeneralResponse(url: string, inputData = {}, headers: any = {}): Promise<any> {
        try {
            headers.platform = 'pwa'
            return await $fetch(this.constructUrl(url), {
                method: 'POST',
                headers,
                body: inputData,
            })
        } catch (e: unknown) {
            if (e instanceof FetchError) {
                this.sentry?.sentryCaptureException?.(e)

                return e.response?._data
            }

            this.sentry?.sentryCaptureException?.(e)

            throw e
        }
    }

    async listUserAddresses(accessToken: string): Promise<GeneralResponse<ListUserAddressesResponse>> {
        return await this.getDataWithGeneralResponse(`/api/v2/user/addresses`, {}, { platform: 'pwa', accessToken })
    }

    async upsertUserAddress(
        address: Omit<UserAddress, 'userId'>,
        accessToken: string
    ): Promise<GeneralResponse<UpsertUserAddressResponse>> {
        return await this.getDataWithGeneralResponse(`/api/v2/user/address/upsert`, address, { platform: 'pwa', accessToken })
    }

    async setCurrentUserAddress(addressId: number, accessToken: string): Promise<GeneralResponse<{ success: boolean }>> {
        return await this.getDataWithGeneralResponse(`/api/v2/user/address/set-current`, { addressId }, { platform: 'pwa', accessToken })
    }

    async deleteUserAddress(addressId: number, accessToken: string): Promise<GeneralResponse<{ success: boolean }>> {
        return await this.getDataWithGeneralResponse(`/api/v2/user/address/delete`, { addressId }, { platform: 'pwa', accessToken })
    }
}
